import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaWindowClose } from "react-icons/fa";
import CommonModal from "Components/CommonModal";
import { downloadPrivacyFile } from "JS/API";

const TaxInfoModal = ({ setIsOpenTaxModal, taxInfo }) => {
  const [alert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const navigate = useNavigate();

  const handleDownloadPrivacyFile = async (fileName, originalFileName) => {
    try {
      const blob = await downloadPrivacyFile(fileName, originalFileName);

      if (!(blob instanceof Blob)) {
        throw new Error("Response is not a Blob");
      }

      // 파일 다운로드handleDownload
      const url = window.URL.createObjectURL(blob); // 임시 파일 다운로드 링크 생성
      const a = document.createElement("a"); // 링크 요소 생성
      a.href = url; // 링크 요소의 href 속성 설정
      a.download = originalFileName; // 링크 요소의 download 속성 설정
      document.body.appendChild(a); // 링크 요소를 문서에 추가
      a.click(); // 링크 요소 클릭
      window.URL.revokeObjectURL(url); // 링크 요소 제거
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading privacy file:", error);
      // 에러 처리 (예: 알림 표시)
    }
  };

  // taxInfo 구조 분해
  const {
          company,
          biz_regist_number,
          email,
          tax_invoice_type,
          merchant_price,
          biz_license_original_filename,
          biz_license_filename,
        } = taxInfo || {};

  return (
    <>
      <div className="modal-background">
        <div className="personnel-modal-container">
          <div className="personnel-modal-header">
            <h3 className="personnel-modal-title">세금 계산서</h3>
            <div
              className="personnel-modal-close"
              onClick={() => {
                setIsOpenTaxModal(false);
              }}
            >
              <FaWindowClose />
            </div>
          </div>

          <div style={{
            padding: '20px',
            display: 'flex',
            gap: "20px"
          }}>
            <p>세금계산서 발행 여부 :</p>
            <p>
              {tax_invoice_type !== "none" ? "발행" : "미발행"}
            </p>
          </div>
          <hr />
          <div style={{
            padding: '20px'
          }}>
            금액 : {merchant_price?.toLocaleString()}원
          </div>

          {tax_invoice_type === "private" && (
            <div>
              <div className="column" style={{
                padding: '20px'
              }}>
                <span>개인 발행</span>
                <span>핸드폰 번호: {taxInfo?.phone || "-"}</span>
              </div>
            </div>
          )}

          {tax_invoice_type === "business" && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <div className="column" style={{
                alignItems: "flex-start",
                padding: '20px',
                gap : '10px'
              }}>
                <span>사업자 발행</span>
                <span>사업자등록번호: {biz_regist_number || "-"}</span>
                <span>회사명: {company || "-"}</span>
                <span>소유주명: {taxInfo?.owner || "-"}</span>
                <span>이메일: {email || "-"}</span>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <p>사업자 등록증: {biz_license_original_filename || "-"}</p>
                  {biz_license_filename && (
                    <button
                      style={{
                        backgroundColor: 'rgb(67, 67, 67)',
                        color: 'white',
                        padding: '5px 10px',
                        borderRadius : '4px'
                      }}
                      onClick={() =>
                        handleDownloadPrivacyFile(
                          biz_license_filename,
                          biz_license_original_filename
                        )
                      }
                    >
                      다운로드
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

        </div>
      </div>

      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "closeModal") setIsOpenTaxModal(false);
            if (alert === "logout") navigate("/");
          }}
        />
      )}
    </>
  );
};

export default TaxInfoModal;
